var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-4989,15343h-16a2,2,0,0,1-2-2v-16a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v16A2,2,0,0,1-4989,15343Zm-10.582-6.354h0a4.461,4.461,0,0,0,.438.254l.331,1.659a.546.546,0,0,0,.536.439h2.183a.544.544,0,0,0,.535-.439l.331-1.659c.148-.077.3-.162.439-.254l1.606.543a.535.535,0,0,0,.172.027.551.551,0,0,0,.475-.274l1.089-1.887a.542.542,0,0,0-.111-.682l-1.271-1.12c0-.078.008-.167.008-.254s0-.164-.008-.254l1.271-1.121a.542.542,0,0,0,.111-.682l-1.089-1.887a.549.549,0,0,0-.473-.275.529.529,0,0,0-.174.029l-1.606.543a4.756,4.756,0,0,0-.439-.254l-.331-1.66a.552.552,0,0,0-.535-.438h-2.183a.547.547,0,0,0-.536.438l-.331,1.66a4.169,4.169,0,0,0-.439.254l-1.605-.543a.533.533,0,0,0-.175-.029.542.542,0,0,0-.472.274l-1.094,1.888a.547.547,0,0,0,.112.682l1.274,1.121c0,.081-.008.168-.008.254s0,.178.008.251l-1.274,1.123a.548.548,0,0,0-.112.682l1.094,1.887a.54.54,0,0,0,.472.276.533.533,0,0,0,.175-.029l1.6-.543Zm2.4-1.464a2.184,2.184,0,0,1-2.179-2.183,2.184,2.184,0,0,1,2.179-2.184A2.186,2.186,0,0,1-4995,15333,2.186,2.186,0,0,1-4997.187,15335.183Z",
    transform: "translate(5006.998 -15323)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.cd29cd65437c2531066b6a3a9d392f37.svg";
export { ForwardRef as ReactComponent };